import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting, AiOutlineWhatsApp, AiOutlineInstagram, AiOutlineShareAlt } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine, RiTelegramLine } from 'react-icons/ri';
import { FaAward, FaTelegramPlane } from 'react-icons/fa';
import { BsTelegram } from 'react-icons/bs';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import OneUser from '../ones/OneUser';
import MobileInterface from '../MobileInterface';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ topPlayers, setTopPlayers ] = useState([]);
  const [ topLeagueWinners, setTopLeagueWinners ] = useState([]);

  const getTopPlayers = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-top-players', { }).then(response => {
        if(response.status === 1) {
          setTopPlayers(response.topPlayers);
          resolve();
        } else {
          appContext.tellError(response.msg);
        }
      })
    })
  }

  const getTopleagueWinners = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-top-league-winners', { }).then(response => {
        if(response.status === 1) {
          setTopLeagueWinners(response.topLeagueWinners);
          resolve();
        } else {
          appContext.tellError(response.msg);
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getTopPlayers().then( async () => {
      await getTopleagueWinners().then( () => {
        setReady(true);
      })
    })
  }

  const openTelegram = () => {
    //open telegram (native) provide telegram link
    MobileInterface.openLink('https://t.me/soldrax1');
  }

  const openWhatsapp = () => {
    //open whatsapp (native) provide number
    MobileInterface.openLink('https://wa.me/+255758779913');
  }

  const openInstagram = () => {
    //open instagram (native) provide link
    MobileInterface.openLink('https://instagram.com/soldrax_app');
  }

  const ratePlaystore = () => {
    //trigger playstore rating (native) provide package name
    MobileInterface.rateApp();
  }

  const shareApp = () => {
    //trigger app sharing (native) provide playstore link
    MobileInterface.shareApp();
  }

  const buyCoins = () => {
    appContext.navTo({ item: 'coins_shop' });
  }

  const openRecentUsers = () => {
    appContext.navTo({ item: 'recent_users' });
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Extras"/>
        <div className="FullPane"  data-support-top-bar={true} style={{ paddingBottom: "var(--topBarheight)" }}>
          <div className="container">
            <div className="row">

              <div className="col-md-12 col-sm-12" style={{ marginTop: "20px" }}>
                <div className="row">
                  
                  <div onClick={openWhatsapp} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
                    <AiOutlineWhatsApp color="#209e30" size={60}/>
                    <small className="form-text">Contact Support on WhatsApp</small>
                  </div>

                  <div onClick={openInstagram} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
                    <AiOutlineInstagram color="#c72248" size={60}/>
                    <small className="form-text">Follow Us on Instagram</small>
                  </div>

                  <div onClick={ratePlaystore} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
                    <IoLogoGooglePlaystore size={60}/>
                    <small className="form-text">Rate Us On Playstore</small>
                  </div>

                  <div onClick={shareApp} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
                    <AiOutlineShareAlt color="#3da5eb" size={60}/>
                    <small className="form-text">Share Soldrax App</small>
                  </div>

                  <div  onClick={buyCoins} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
                    <AiFillDollarCircle color="var(--goldish)" size={60}/>
                    <small className="form-text">Buy Coins</small>
                  </div>

                </div>
              </div>

              <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px", borderTop: "1px solid var(--goldish)", paddingTop: "10px" }}>
                <button
                  className='btn bg-dark'
                  onClick={openRecentUsers}
                >
                  Click here to Discover online or recently online players
                </button>
              </div>

              <div className="col-md-12 col-sm-12" style={{ marginTop: "20px", borderTop: "1px solid var(--goldish)", paddingTop: "10px" }}>
                <p className="font-light" style={{ fontSize: "12px" }}>
                  SolDrax aims to make board games especially (but not limited to) Cards and Checkers accessible to everyone, everywhere. Users can also make money as
                  they play by participating in leagues and other organised competitions
                </p>

                <small className="form-text">soldrax@werenium.com</small>
                <small className="form-text">+255 749 487 578</small>
                <small className="form-text">&copy;Werenium</small>
              </div>

              <div className="col-md-12 col-sm-12" style={{ marginTop: "20px" }}>
                <div className="card text-start">
                  <div className="card-body">
                    {/*
                    <h5 className="text-whitish font-regular">Soldrax Top League Winners</h5>
                    <hr/>
                    {
                      (topLeagueWinners.length > 0) ?
                      topLeagueWinners.map((item, i) => {
                        return (
                          <OneUser key={i} username={item.username} id={item.id} />
                        )
                      }):
                      <h6 className="text-muted">No players were found</h6>
                    }
                    */}


                    <h5 className="text-whitish font-regular" style={{ marginTop: "0" }}>Soldrax Top Players</h5>
                    <hr/>
                    {
                      (topPlayers.length > 0) ?
                      topPlayers.map((item, i) => {
                        return (
                          <OneUser key={i} username={item.username} id={item.id} />
                        )
                      }):
                      <h6 className="text-muted">No players were found</h6>
                    }
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
